/**
 * @author Felipe Leonhardt
 * http://www.vision-ti.com.br
 */
export abstract class GenericModel {
    id: number;
    tenant:string;
    status:string;
    
}